require('./bootstrap');

window.ajaxSetup = $.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    },
    error: function (res) {
        errorAlert(res.responseJSON.error);
    }
});

window.errorAlert = (message) => {
    Swal.fire({
        title: 'Xəta!',
        text: message,
        icon: 'error',
        confirmButtonText: 'Bağla'
    })
}

window.successAlert = (message) => {
    Swal.fire({
        title: 'Uğurlu!',
        text: message,
        icon: 'success',
        confirmButtonText: 'Bağla'
    })
}


window.countdownTimer = (minute, second) => {
    var timer2 = `${minute}:${second}`;
    var interval = setInterval(function () {


        var timer = timer2.split(':');
        //by parsing integer, I avoid all extra string processing
        var minutes = parseInt(timer[0], 10);
        var seconds = parseInt(timer[1], 10);
        --seconds;
        minutes = (seconds < 0) ? --minutes : minutes;
        if (minutes < 0 && seconds <= 1) {
            window.location.reload();
        }
        if (minutes < 0) clearInterval(interval);
        seconds = (seconds < 0) ? 59 : seconds;
        seconds = (seconds < 10) ? '0' + seconds : seconds;

        $('#countdown').html(minutes + ':' + seconds);
        timer2 = minutes + ':' + seconds;

        if (parseInt(minutes) == 0 && parseInt(seconds) < 1) {

            $('#countdown').hide();

            window.location.refresh();
        }
    }, 1000);


}
